<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div v-show="!modoEdicao" class="row-space">
        <div v-if="lsDados.length>0">
            <div class="table-wrapper row-space">
                <table>
                    <thead>
                        <tr>
                            <th>Protocolo</th>
                            <th>Processo</th>
                            <th>S.I.M.</th>
                            <th>Estabelecimento</th>
                            <th>Etapa</th>
                            <th>Prazo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in lsDados" :key="item.id" @click="onClickItem(item)"
                        :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                            <td class="col-width-char20 center">{{ item.protocolo }}</td>
                            <td class="col-width-char40">{{ item.nmprocesso }}</td>
                            <td class="col-width-char40">{{ item.nmsim }}</td>
                            <td>{{ item.nmestabelecimento }}</td>
                            <td class="col-width-char30">{{ item.nmetapa }}</td>
                            <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(item.dtprazo) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div v-if="showPagination" class="pagination">
                <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
                <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
                <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
                <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
            </div>

            <div class="row-center">
                <button class="btn-small" @click="closeForm">Voltar</button>
            </div>
        </div>


        <div v-else>
            <EmptyStateComponent 
                :title="'Protocolar Assinaturas'"
                :message="'No momento não existe nenhum processo pendente para o seu usuário!'"
                :button-text="'Voltar'"
                @action="closeForm"
            />
        </div>
    </div>


    <div v-if="modoEdicao">
        <ProcEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @save="lerDados" />
    </div>
    <!-- <div class="json-debug">{{ lsDados }}</div> -->
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/funcoes';
import { globalStore } from '@/globals';
import EmptyStateComponent from '@/components/EmptyStateComponent.vue';
import ProcEditPage from '../formularios/ProcEditPage.vue';

const emit = defineEmits(['close']);

const idEdicao = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const msgAlerta = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


function closeForm() {emit('close');}


async function lerDados() {
    try {
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/dados/proc/pendentes', {
            idep: globalStore.idep,
            idreferencia: globalStore.idperfil
        });
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function onClickItem(obj){
    idEdicao.value = obj.id;
    modoEdicao.value = true;
}


const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>